import {Tabs} from 'flowbite';

window.initTabs = function initTabs(tabsElementId, onShowCallback = null, onNavigateCallback = null) {
    const tabsElement = document.getElementById(tabsElementId);

    const tabElements = Array.from(tabsElement.querySelectorAll('[role="tab"]'))
        .map(el => {
            const targetEl = document.querySelector(el.dataset.tabsTarget);

            return {
                id: el.id,
                triggerEl: el,
                targetEl: targetEl,
                isDefaultActive: !!el.dataset.tabsDefaultActive,
            };
        });

    const urlParams = new URLSearchParams(window.location.search);
    const tabFromUrl = urlParams.get('tab');
    const activeTabFromUrl = tabFromUrl ? tabElements.find(el => el.id === tabFromUrl + '-tab') : null;
    const activeTabFromHtml = tabElements.find(el => el.isDefaultActive);
    const defaultTabId = activeTabFromUrl?.id || activeTabFromHtml?.id || tabElements[0].id;


    const options = {
        defaultTabId,
        activeClasses:
            'text-sky-600 bg-sky-100 dark:bg-sky-950 dark:text-sky-500 dark:hover:text-sky-300 border-b-sky-600 dark:border-b-sky-500',
        inactiveClasses:
            'text-gray-500 hover:text-gray-600 dark:text-gray-400 border-b-transparent hover:border-b-gray-300 dark:hover:text-gray-300',
    };

    if (onShowCallback) {
        options.onShow = onShowCallback;
    }

    const instanceOptions = {
        id: tabsElementId,
        override: true
    };

    const tabsInstance = new Tabs(tabsElement, tabElements, options, instanceOptions);

    if (onNavigateCallback) {
        tabsInstance.updateOnShow(onNavigateCallback);
    }

    return tabsInstance
}
